<template>
    <div>
        <h1>Examples</h1>
        <ds-examples-list />
    </div>
</template>
